import { render, staticRenderFns } from "./PassiveStock.vue?vue&type=template&id=3aa0facb&scoped=true"
import script from "./PassiveStock.vue?vue&type=script&lang=js"
export * from "./PassiveStock.vue?vue&type=script&lang=js"
import style0 from "./PassiveStock.vue?vue&type=style&index=0&id=3aa0facb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa0facb",
  null
  
)

export default component.exports